import { useEffect, useRef } from 'react'

function extractJsonFromScriptTag(scriptStr: string): string {
  // Create a dummy element to parse the string
  const div = document.createElement('div')
  div.innerHTML = scriptStr
  const script = div.querySelector('script')

  return script?.textContent?.trim() || ''
}

const useSchema = (schemas: Array<string | null | undefined>) => {
  const ids = useRef<string[]>([])
  // Callers pass inline arrays, so key the effect on content rather than
  // identity — otherwise the <head> scripts are torn down and recreated on
  // every render of the consuming page.
  const schemasKey = JSON.stringify(schemas)

  const clean = () => {
    ids.current.forEach(id => {
      document.getElementById(id)?.remove()
    })
    ids.current = []
  }
  useEffect(() => {
    const filtered = schemas.filter(Boolean)
    if (filtered.length === 0) return

    clean()

    filtered.forEach(schema => {
      const script = document.createElement('script')
      script.type = 'application/ld+json'
      script.id = Math.random().toString()
      ids.current = [...ids.current, script.id]
      script.text = extractJsonFromScriptTag(schema as string)

      document.head.appendChild(script)
    })

    return () => {
      clean()
    }
  }, [schemasKey])
}

export default useSchema
